import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { Revision } from '../../../version-control/revision/revision.model';
import { AppState } from '../../../model/reducer';
import { select, Store } from '@ngrx/store';
import { LocalStatus, MetaInfo } from '../../../version-control/meta-info.model';
import { LoadRevision } from '../../../model/version-control';
import { requireNonNull } from '../../utils/utils';
import { Observable } from 'rxjs';

/**
 * This component represents the content of the popover window for the uncommited changes
 */
@Component({
    selector: 'adm4-local-changes-popup',
    template: `
    <div class='un-container'>
      @if (metaInfo) {
        @if (metaInfo.localStatus !== UNMODIFIED_STATUS) {
          <span>
            <div>{{metaInfo.localStatus | capitalizeFirst}} by {{metaInfo?.localAuthor}}, {{metaInfo?.localDate | date:'MMMM d, y'}} at {{metaInfo?.localDate | date: 'HH:mm'}}</div>
            <a (click)='triggerPublish()'>
              <i class="fa fa-upload left-icon" aria-hidden="true"></i>
              <span class='publish-text'>Publish changes</span>
            </a>
          </span>
        }
        @if (metaInfo.localStatus === UNMODIFIED_STATUS) {
          <span>
            Modified by {{(revision$ | async)?.committer.name}}, {{(revision$ | async)?.committer.when | date:'MMMM d, y'}} at {{(revision$ | async)?.committer.when | date:'HH:mm'}}
          </span>
        }
      } @else {
        <span>Loading...</span>
      }
    </div>
    `,
    styleUrls: ['./local-changes-popup.component.scss'],
    standalone: false
})
export class LocalChangesPopupComponent implements OnChanges {
  private store$ = inject<Store<AppState>>(Store);

  @Input() metaInfo: MetaInfo;
  @Output() publishClick: EventEmitter<undefined> = new EventEmitter();
  public revision$: Observable<Revision>;

  public UNMODIFIED_STATUS = LocalStatus.Unmodified;

  constructor() {
    this.revision$ = this.store$.pipe(select(state => state.versionControl.revisions[this.metaInfo.commitId || '']));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.metaInfo && LocalStatus.Unmodified === this.metaInfo?.localStatus) {
      this.store$.dispatch(new LoadRevision(requireNonNull(this.metaInfo.commitId)));
    }
  }

  triggerPublish(): void {
    this.publishClick.emit();
  }
}
